import BannerGeneral from "../../components/BannerGeneral";
import BlockBackgroundImage from "../../components/BlockBackgroundImage";
import BlockLeftImage from "../../components/BlockLeftImage";
import BlockRightImage from "../../components/BlockRightImage";
import SocialShare from "../../components/SocialShare";

function ImpactoSocial() {
  return (
    <>
      <div className="   padding ">
        <article class="nota-utpl" lang="es">
          <div className=" padding2 layout6 ">
            <header>
              <h2>
                UTPL reconocida en SCImago 2025:
                <b> segundo lugar nacional en Impacto Social</b>
              </h2>
            </header>
            <p>
              El SCImago Institutions Rankings (SIR) es una de las
              clasificaciones internacionales más prestigiosas, que evalúa el
              desempeño integral de universidades e instituciones de
              investigación en tres grandes dimensiones:
            </p>
            <ul>
              {" "}
              <li>
                <b>Investigación: </b> mide la producción científica, la calidad
                de las publicaciones, la colaboración internacional y el impacto
                de la investigación a través de indicadores como el índice H.
              </li>
              <li>
                <b>Innovación:</b> valora la transferencia de conocimiento a la
                sociedad, la capacidad para generar patentes, desarrollo
                tecnológico y vínculos con el sector productivo.
              </li>
              <li>
                <b> Impacto Social: </b> analiza la visibilidad web, el uso de
                resultados en políticas públicas, la producción científica
                vinculada a los Objetivos de Desarrollo Sostenible (ODS) y la
                participación femenina en investigación.
              </li>
            </ul>
            <p>
              En la edición 2025, nos enorgullece comunicar que la UTPL ocupa el
              <b>
                {" "}
                segundo lugar a nivel nacional en la dimensión de Impacto
                Social, ubicándose en el top 10 de las mejores universidades del
                Ecuador
              </b>
              , un reconocimiento que reafirma nuestro liderazgo en la
              generación de conocimiento con pertinencia y compromiso hacia la
              sociedad.
            </p>
            <h3>
              Compromiso con los <b>Objetivos de Desarrollo Sostenible</b>
            </h3>
            <p>
              Reafirmamos este compromiso mediante el alineamiento con los{" "}
              <b> ODS de la ONU,</b> en áreas como la equidad de género, el
              desarrollo sostenible y la innovación social. Este logro es
              posible gracias al talento, esfuerzo y compromiso de toda nuestra
              comunidad académica, que contribuye a la construcción de un futuro
              más justo y sostenible para el Ecuador y el mundo.
            </p>
            <br></br>
            <img
              src="https://www.utpl.edu.ec/carreras/sites/default/files/foto%20mujeres%20UTPL_0.png"
              alt="utpl impacto social"
            ></img>
            <br></br>
            <h3>
              Liderazgo de <b>mujeres investigadoras</b>
            </h3>
            <p>
              En la <strong>UTPL</strong>, las investigadoras marcan la
              diferencia:
            </p>
            <ul>
              <li>
                <strong>55 %</strong> de nuestros investigadores son mujeres.
              </li>
              <li>
                <strong>43 %</strong> de los grupos de investigación son
                liderados por investigadoras.
              </li>
              <li>
                <strong>58 %</strong> de las publicaciones de impacto mundial
                (SCOPUS y WOS) son realizadas por mujeres.
              </li>
              <li>
                <strong>57 %</strong> de las publicaciones de impacto regional
                (LATINDEX) son elaboradas por investigadoras.
              </li>
            </ul>
            <br></br>
            <h3>
              Investigación que <b>trasciende</b>
            </h3>{" "}
          </div>
          <div className="layout6 lightbluebg">
            <BlockRightImage
              src="https://sica.utpl.edu.ec/media/uploads/docentes/fotos/web/low/1104114119_low.jpg"
              content={
                <>
                  {" "}
                  <p>
                    La docente Diana Jumbo, investigadora de la Facultad de
                    Ciencias Exactas y Naturales, ha desarrollado un proyecto
                    innovador que convierte residuos de relaves mineros en
                    bioladrillos, un material de construcción ecológico,
                    resistente y sostenible. Gracias a un proceso biológico que
                    une las partículas de relave, estos bioladrillos reducen
                    significativamente la huella de carbono y contribuyen a
                    minimizar la contaminación ambiental, ofreciendo una
                    alternativa amigable con el planeta para la construcción.
                  </p>{" "}
                </>
              }
            >
              {" "}
            </BlockRightImage>
          </div>
          <h3 className="layout6 padding">
            La <strong>UTPL</strong> ha consolidado un entorno en el que
            investigadoras e investigadores son protagonistas del cambio,
            liderando proyectos que aportan al desarrollo local y global,
            fortalecen la innovación y la transferencia de conocimiento, y
            reflejan el verdadero
            <strong> impacto social</strong> que nuestra universidad busca
            generar
          </h3>{" "}
        </article>

        <center>
          <h4>Comparte esta noticia</h4>

          <SocialShare
            title="UTPL reconocida en SCImago 2025: segundo lugar nacional en Impacto Social"
            url="https://utpl.edu.ec/reconocidos-en-impacto-social"
          >
            {" "}
          </SocialShare>
        </center>
      </div>

      <BannerGeneral></BannerGeneral>
    </>
  );
}

export default ImpactoSocial;
